import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as IcSave } from "../../../../../Assets/Images/Save.svg";
import { ReactComponent as IcSaved } from "../../../../../Assets/Images/Saved.svg";
import { Config } from "../../../../../Config";
import CandidateDetailsModal from "./CandidateDetailsModal";
import PercentageIndicator from "./PercentageIndicator";

const FlippedComponent = (props) => {
  const [checkInfo, setCheckInfo] = useState({
    isChecked: props.content.bookmarked,
  });

  const handleCheckedRow = () => {
    if (!props.SelectedDataNames.includes(props.SelectedDataName)) {
      props.HandleSelectData(props.SelectedDataName)
    }
    if (props.content.bookmarked) {
      props.RemoveBookmark(props.content);
    } else {
      props.AddBookmark(props.content);
    }

    setCheckInfo({...checkInfo, isChecked: !checkInfo.isChecked});
  };

  useEffect(() => {
    setCheckInfo({ ...checkInfo, isChecked: props.content.bookmarked});
    let jpaTypeId = "";
    switch (props.SelectedDataName) {
      case "projects":
        jpaTypeId = "projectId";
        break;
      case "activities":
        jpaTypeId = "activityId";
        break;
      default: //positions
        jpaTypeId = "positionId";
    }
    if (props.content.bookmarked) {
      props.RemovedBookmark.forEach((bookmark) => {
        if (bookmark[jpaTypeId] === props.content.id)
          setCheckInfo({ ...checkInfo, isChecked: false });
      });
    } else {
      props.AddedBookmark.forEach((bookmark) => {
        if (bookmark[jpaTypeId] === props.content.id)
          setCheckInfo({ ...checkInfo, isChecked: true });
      });
    }
  }, [props.RemovedBookmark, props.AddedBookmark, props.SelectedDataName, props.content, props.SelectedDataNames]);

  useEffect(() => {
    if (props.HasRemoveAllSelectedJPABookmark.hasRemoved && props.HasRemoveAllSelectedJPABookmark.JPAType === props.SelectedDataName){
      let jpaTypeId = "";
      switch (props.SelectedDataName) {
        case "projects":
          jpaTypeId = "projectId";
          break;
        case "activities":
          jpaTypeId = "activityId";
          break;
        default: //positions
          jpaTypeId = "positionId";
      }
      if (props.content.bookmarked) {
        if (!props.RemovedBookmark.find(bookmark => bookmark[jpaTypeId] === props.content.id)){
          props.RemoveBookmark(props.content)
        }
      } else {
        props.AddedBookmark.forEach((bookmark) => {
          if (bookmark[jpaTypeId] === props.content.id)
            props.AddBookmark(props.content);
        });
      }
      props.ResetHasRemoveAllSelectedJPABookmark()
    }
  }, [props.HasRemoveAllSelectedJPABookmark, props.SelectedDataName, props.RemovedBookmark, props.AddedBookmark])

  return (
    <>
      <div className="content-flipped-row" onClick={handleCheckedRow}>
        <i
          id={props.content.id + "-check"}
          className={`radio-btn ${checkInfo.isChecked && "checked"}`}
        />
        <p className="content-flipped-row-name">{props.content.title}</p>
      </div>
    </>
  );
};

const CandidateCard = (props) => {
  const JPANames = ["positions", "projects", "activities"];
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const flippedElement = useRef();
  const [isFlipped, setIsFlipped] = useState(false);
  const [UniqueTitles, setUniqueTitles] = useState({});
  const [SelectedDataName, setSelectedDataName] = useState(""); //positions | projects | activities
  const [SelectedDataNames, setSelectedDataNames] = useState([]); // array of positions | projects | activities
  const [ShowSearchInput, setShowSearchInput] = useState(false);
  const [ContentSavedTitle, setContentSavedTitle] = useState([]);
  const [TotalContentSaved, setTotalContentSaved] = useState(0);
  const [SearchInput, setSearchInput] = useState("");
  const [AddedBookmark, setAddedBookmark] = useState([]);
  const [RemovedBookmark, setRemovedBookmark] = useState([]);
  const [AddedBookmarkPosition, setAddedBookmarkPosition] = useState([]);
  const [AddedBookmarkProject, setAddedBookmarkProject] = useState([]);
  const [AddedBookmarkActivity, setAddedBookmarkActivity] = useState([]);
  const [RemovedBookmarkPosition, setRemovedBookmarkPosition] = useState([]);
  const [RemovedBookmarkProject, setRemovedBookmarkProject] = useState([]);
  const [RemovedBookmarkActivity, setRemovedBookmarkActivity] = useState([]);
  const [BookmarkedPositions, setBookmarkedPositions] = useState([]);
  const [BookmarkedProjects, setBookmarkedProjects] = useState([]);
  const [BookmarkedActivities, setBookmarkedActivities] = useState([]);
  const [HasRemoveAllSelectedJPABookmark,setHasRemoveAllSelectedJPABookmark] = useState({
    hasRemoved: false,
    JPAType: null
  })

  /* rendering conditions
    1. bold the text and show the flipped component based on the props.JPAType
    2. if the jpa bookmark exist, then check the box, if not, only bold the text and show flipped component
  */
  useEffect(() => {
    saveUniqueTitles();
    if (props.JPAType === "position") {
      setSelectedDataName("positions");
    } else if (props.JPAType === "project") {
      setSelectedDataName("projects");
    } else if (props.JPAType === "activity") {
      setSelectedDataName("activities");
    }
  }, []);

  useEffect(() => {
    if (UniqueTitles[SelectedDataName]) {
      const bookmarkedTitle = UniqueTitles[SelectedDataName].filter(
        (data) => data.bookmarked
      );
      setContentSavedTitle(bookmarkedTitle);
    }
  }, [SelectedDataName, UniqueTitles]);

  useEffect(() => {
    const BookmarkedJPAs = [];
    for (let i = 0; i < JPANames.length; i++) {
      if (UniqueTitles[JPANames[i]]) {
        const bookmarkedTitle = UniqueTitles[JPANames[i]].find(
          (data) => data.bookmarked
        );
        if (bookmarkedTitle) BookmarkedJPAs.push(JPANames[i]);
      }
    }
    setSelectedDataNames(BookmarkedJPAs);
    const bookmarkedPosition = UniqueTitles["positions"]
      ?.filter((data) => data.bookmarked)
      .map((data) => {
        return addedItemInfo(data, 'positionId').addedItem;
      });
    const bookmarkedProject = UniqueTitles["projects"]
      ?.filter((data) => data.bookmarked)
      .map((data) => {
        return addedItemInfo(data, 'projectId').addedItem;
      });
    const bookmarkedActivity = UniqueTitles["activities"]
      ?.filter((data) => data.bookmarked)
      .map((data) => {
        return addedItemInfo(data, 'activityId').addedItem;
      });
    setBookmarkedPositions(bookmarkedPosition);
    setBookmarkedProjects(bookmarkedProject);
    setBookmarkedActivities(bookmarkedActivity);
    if (bookmarkedPosition && bookmarkedProject && bookmarkedActivity)
      setTotalContentSaved(
        bookmarkedPosition.length +
          bookmarkedProject.length +
          bookmarkedActivity.length
      );
  }, [UniqueTitles]);

  useEffect(() => {
    if (!props.IsCardSavedOpened) flippedElement.current.style.zIndex = `0`;
  }, [props.IsCardSavedOpened]);

  useEffect(() => {
    if (props.candidate.id === props.ChangedCandidateBookmark.id) {
      console.log("refetching unique titles", props.ChangedCandidateBookmark);
      saveUniqueTitles();
    }
  }, [props.ChangedCandidateBookmark]);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const handleFlippedCard = () => {
    setIsFlipped(!isFlipped);
    if (isFlipped) {
      flippedElement.current.style.transform = "";
      flippedElement.current.style.zIndex = "0";
    } else {
      flippedElement.current.style.transform = "rotateY(180deg) scaleX(-1)";
      flippedElement.current.style.zIndex = `${props.FlipCount + 99999}`;
    }
    props.AddFlipCount(props.CardIdx);
  };

  const shortenText = (text, Length) => {
    if (text) {
      if (text.length <= Length) {
        return text;
      } else {
        let Short = text.slice(0, Length) + "...";
        return (
          <>
            <p className="popup-text">{text}</p>
            {Short}
          </>
        );
      }
    }
  };

  const selectData = () => {
    if (SelectedDataName) {
      if (SearchInput)
        return UniqueTitles[SelectedDataName].filter((data) =>
          data.title.toLowerCase().includes(SearchInput.toLowerCase())
        );
      return UniqueTitles[SelectedDataName];
    }
  };

  const saveUniqueTitles = () => {
    let Data = {
      positions: [],
      projects: [],
      activities: [],
    };

    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/find-my-positions?candidateId=" +
        props.candidate.id,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        Data.positions = Res.data;

        let Req = {
          method: "GET",
          baseURL:
            window._env_.API_URL +
            Config.ProjectServiceURL +
            "/api/project/find-my-projects?candidateId=" +
            props.candidate.id,
          headers: {
            Authorization: "Bearer " + window.localStorage.getItem("Token"),
          },
        };
        axios(Req)
          .then((Res) => {
            console.log(Res);
            Data.projects = Res.data;

            let Req = {
              method: "GET",
              baseURL:
                window._env_.API_URL +
                Config.ActivityServiceURL +
                "/api/activity/find-my-activities?candidateId=" +
                props.candidate.id,
              headers: {
                Authorization: "Bearer " + window.localStorage.getItem("Token"),
              },
            };
            axios(Req)
              .then((Res) => {
                console.log(Res);
                Data.activities = Res.data;
                setUniqueTitles(Data);
              })
              .catch((Err) => {
                console.log(Err);
              });
          })
          .catch((Err) => {
            console.log(Err);
          });
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const handleSave = async () => {
    /* Logic
    1. if selected data names is checked, we evaluate if individual items are being removed / added
    2. if selected data names is unchecked, we need to remove every item that was bookmarked on that unchecked JPAs
     */

    //JPA Name: position
    if (SelectedDataNames.includes("positions")) {
      if (AddedBookmarkPosition.length === 0 && BookmarkedPositions.length === RemovedBookmarkPosition.length) {
        props.ShowError(true)
        return
      }
      if (RemovedBookmarkPosition.length)
        await handleSaveBookmark("positions", true);
      if (AddedBookmarkPosition.length)
        await handleSaveBookmark("positions", false);
    } else {
      if (BookmarkedPositions.length)
        await handleSaveBookmark("positions", true, true);
    }

    //JPA Name: project
    if (SelectedDataNames.includes("projects")) {
      if (AddedBookmarkProject.length === 0 && BookmarkedProjects.length === RemovedBookmarkProject.length) {
        props.ShowError(true)
        return
      }
      if (RemovedBookmarkProject.length)
        await handleSaveBookmark("projects", true);
      if (AddedBookmarkProject.length)
        await handleSaveBookmark("projects", false);
    } else {
      if (BookmarkedProjects.length)
        await handleSaveBookmark("projects", true, true);
    }

    //JPA Name: activity
    if (SelectedDataNames.includes("activities")) {
      if (AddedBookmarkActivity.length === 0 && BookmarkedActivities.length === RemovedBookmarkActivity.length) {
        props.ShowError(true)
        return
      }
      if (RemovedBookmarkActivity.length)
        await handleSaveBookmark("activities", true);
      if (AddedBookmarkActivity.length)
        await handleSaveBookmark("activities", false);
    } else {
      if (BookmarkedActivities.length)
        await handleSaveBookmark("activities", true, true);
    }

    //TODO: handle when selecteddatanames doesn't include jpa category
    resetAllBookmark();
    setShowSearchInput(false);
    setSearchInput("");
    handleFlippedCard();
    saveUniqueTitles();
    props.ShowError(false);
  };

  const handleSaveBookmark = (jpaType, isRemoved, isJPAUnchecked = false) => {
    let Req = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    switch (jpaType) {
      case "projects":
        Req["baseURL"] =
          window._env_.API_URL +
          Config.ProjectServiceURL +
          "/api/project/chatbot-candidates/bookmark";
        // if the jpa box is unchecked we have to remove all the bookmarked item on that jpa,
        // else we need to check item's in the jpa individually whether they are added or removed
        Req["data"] = isJPAUnchecked
          ? BookmarkedProjects
          : isRemoved
          ? RemovedBookmarkProject
          : AddedBookmarkProject;
        break;
      case "activities":
        Req["baseURL"] =
          window._env_.API_URL +
          Config.ActivityServiceURL +
          "/api/activity/chatbot-candidates/bookmark";
        Req["data"] = isJPAUnchecked
          ? BookmarkedActivities
          : isRemoved
          ? RemovedBookmarkActivity
          : AddedBookmarkActivity;
        break;
      default: // positions
        Req["baseURL"] =
          window._env_.API_URL +
          Config.PositionServiceURL +
          "/api/position/chatbot-candidates/bookmark";
        Req["data"] = isJPAUnchecked
          ? BookmarkedPositions
          : isRemoved
          ? RemovedBookmarkPosition
          : AddedBookmarkPosition;
    }
    return axios(Req);
  };

  const resetAllBookmark = () => {
    setRemovedBookmark([]);
    setRemovedBookmarkPosition([]);
    setRemovedBookmarkProject([]);
    setRemovedBookmarkActivity([]);
    setAddedBookmark([]);
    setAddedBookmarkPosition([]);
    setAddedBookmarkActivity([]);
    setAddedBookmarkProject([]);
  };
  const handleSelectData = (name) => {
    if (SelectedDataNames.includes(name)) {
      setHasRemoveAllSelectedJPABookmark({hasRemoved: true, JPAType: name})
      setSelectedDataNames((prevState) =>
        prevState.filter((state) => state !== name)
      );
    } else {
      setSelectedDataNames((prevState) => [...prevState, name]);
    }
  };

  const handleSelectDataName = (name) => {
    setSelectedDataName(name);
  };

  const toggleShowSearchInput = (bool) => {
    if (bool) {
      props.AddFlipCount(props.CardIdx);
      flippedElement.current.style.zIndex = `${props.FlipCount + 99999}`;
    }
    setShowSearchInput(bool);
    setSearchInput("");
  };

  const addedItemInfo = (content, jpaTypeName = null) => {
    let jpaTypeId = "";
    if (SelectedDataName === "positions") {
      jpaTypeId = "positionId";
    } else if (SelectedDataName === "projects") {
      jpaTypeId = "projectId";
    } else if (SelectedDataName === "activities") {
      jpaTypeId = "activityId";
    }
    const addedItem = {
      candidateId: props.candidate.id,
      requestId: props.SavedRequestId,
    };

    if (jpaTypeName) addedItem[jpaTypeName] = content.id
    else addedItem[jpaTypeId] = content.id;

    return { jpaTypeId, addedItem };
  };

  const handleAddBookmark = (content, jpaTypeName=null, mustRemove=false) => {
    let { jpaTypeId, addedItem } = addedItemInfo(content, jpaTypeName);
    let hasDuplicate = false;
    let duplicatedId = -1;

    AddedBookmark.forEach((bookmark) => {
      if (bookmark[jpaTypeId] === content.id) {
        hasDuplicate = true;
        duplicatedId = content.id;
      }
    });
    if (!hasDuplicate) {
      setAddedBookmark((prevState) => [...prevState, addedItem]);
      props.ShowError(false)
      switch (SelectedDataName) {
        case "projects":
          setAddedBookmarkProject((prevState) => [...prevState, addedItem]);
          break;
        case "activities":
          setAddedBookmarkActivity((prevState) => [...prevState, addedItem]);
          break;
        default: //positions
          setAddedBookmarkPosition((prevState) => [...prevState, addedItem]);
      }
    }
    if (hasDuplicate) {
      setAddedBookmark(
        AddedBookmark.filter((bookmark) => bookmark[jpaTypeId] !== duplicatedId)
      );
      switch (SelectedDataName) {
        case "projects":
          setAddedBookmarkProject(
            AddedBookmarkProject.filter(
              (bookmark) => bookmark[jpaTypeId] !== duplicatedId
            )
          );
          break;
        case "activities":
          setAddedBookmarkActivity(
            AddedBookmarkActivity.filter(
              (bookmark) => bookmark[jpaTypeId] !== duplicatedId
            )
          );
          break;
        default: //positions
          setAddedBookmarkPosition(
            AddedBookmarkPosition.filter(
              (bookmark) => bookmark[jpaTypeId] !== duplicatedId
            )
          );
      }
    }
  };

  const handleRemoveBookmark = (content) => {
    let { jpaTypeId, addedItem } = addedItemInfo(content);
    let hasDuplicate = false;
    let duplicatedId = -1;

    RemovedBookmark.forEach((bookmark) => {
      if (bookmark[jpaTypeId] === content.id) {
        hasDuplicate = true
        duplicatedId = content.id
      }
    });
    if (!hasDuplicate) {
      setRemovedBookmark((prevState) => [...prevState, addedItem]);
      switch (SelectedDataName) {
        case "projects":
          setRemovedBookmarkProject((prevState) => [...prevState, addedItem]);
          break;
        case "activities":
          setRemovedBookmarkActivity((prevState) => [...prevState, addedItem]);
          break;
        default: //positions
          setRemovedBookmarkPosition((prevState) => [...prevState, addedItem]);
      }
    }
    if (hasDuplicate) {
      props.ShowError(false)
      setRemovedBookmark(
        RemovedBookmark.filter(
          (bookmark) => bookmark[jpaTypeId] !== duplicatedId
        )
      );
      switch (SelectedDataName) {
        case "projects":
          setRemovedBookmarkProject(
            RemovedBookmark.filter(
              (bookmark) => bookmark[jpaTypeId] !== duplicatedId
            )
          );
          break;
        case "activities":
          setRemovedBookmarkActivity(
            RemovedBookmark.filter(
              (bookmark) => bookmark[jpaTypeId] !== duplicatedId
            )
          );
          break;
        default: //positions
          setRemovedBookmarkPosition(
            RemovedBookmark.filter(
              (bookmark) => bookmark[jpaTypeId] !== duplicatedId
            )
          );
      }
    }
  };

  return (
    <>
      {ModalIsOpen ? (
        <CandidateDetailsModal
          candidate={props.candidate}
          Close={() => setModalIsOpen(false)}
          LangData={props.LangData}
        />
      ) : null}
      {ShowSearchInput && (
        <div
          className="outline"
          onClick={() => toggleShowSearchInput(false)}
        ></div>
      )}
      <div className="candidate-card-inner" ref={flippedElement}>
        {isFlipped ? (
          <div className="candidate-card-back">
            <div className="content-flipped">
              <div className="content-flipped-title">
                {translateText("save_to")}
              </div>
              <div className="content-select-data-container">
                <div className="content-select-data">
                  <i
                    onClick={() => handleSelectData("positions")}
                    className={`radio-btn ${
                      SelectedDataNames.includes("positions") && "checked"
                    }`}
                  />
                  <span
                    onClick={() => handleSelectDataName("positions")}
                    className={`title ${
                      SelectedDataName === "positions" && "bold"
                    }`}
                  >
                    {translateText("vacancy")}
                  </span>
                </div>
                <div className="content-select-data">
                  <i
                    onClick={() => handleSelectData("projects")}
                    className={`radio-btn ${
                      SelectedDataNames.includes("projects") && "checked"
                    }`}
                  />
                  <span
                    onClick={() => handleSelectDataName("projects")}
                    className={`title ${
                      SelectedDataName === "projects" && "bold"
                    }`}
                  >
                    {translateText("project")}
                  </span>
                </div>
                <div className="content-select-data">
                  <i
                    onClick={() => handleSelectData("activities")}
                    className={`radio-btn ${
                      SelectedDataNames.includes("activities") && "checked"
                    }`}
                  />
                  <span
                    onClick={() => handleSelectDataName("activities")}
                    className={`title ${
                      SelectedDataName === "activities" && "bold"
                    }`}
                  >
                    {translateText("activity")}
                  </span>
                </div>
              </div>
              {ShowSearchInput ? (
                <div className="search-input-container">
                  {UniqueTitles[SelectedDataName]?.length ? (
                    <>
                      <div className="search-input">
                        <div className="search-input-left">
                          <i className="feather-search" />
                          <input
                            type="text"
                            value={SearchInput}
                            placeholder={translateText("search")}
                            onChange={(e) => setSearchInput(e.target.value)}
                          />
                        </div>
                        <span
                          className="feather-chevron-up"
                          onClick={() => toggleShowSearchInput(false)}
                        />
                      </div>
                      <div className="content-flipped-container">
                        {selectData()?.map((content, idx) => (
                          <FlippedComponent
                            key={idx}
                            content={content}
                            AddBookmark={(content) =>
                              handleAddBookmark(content)
                            }
                            RemoveBookmark={(content) =>
                              handleRemoveBookmark(content)
                            }
                            SelectedDataName={SelectedDataName}
                            SelectedDataNames={SelectedDataNames}
                            AddedBookmark={AddedBookmark}
                            RemovedBookmark={RemovedBookmark}
                            HandleSelectData={(name) => handleSelectData(name)}
                            ShowError={(bool) => props.ShowError(bool)}
                            HasRemoveAllSelectedJPABookmark={HasRemoveAllSelectedJPABookmark}
                            ResetHasRemoveAllSelectedJPABookmark={() => setHasRemoveAllSelectedJPABookmark({hasRemoved: false, JPAType: null})}
                          />
                        ))}
                      </div>
                    </>
                  ) : (
                    <div
                      className="content-no-jpa"
                      onClick={() => toggleShowSearchInput(false)}
                    >
                      <span>There are no {SelectedDataName} to select</span>
                      <span className="feather-chevron-up"></span>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className="content-saved-title"
                  onClick={() => toggleShowSearchInput(true)}
                >
                  {SelectedDataName === "positions" && (
                    <span>
                      {HasRemoveAllSelectedJPABookmark.hasRemoved && HasRemoveAllSelectedJPABookmark.JPAType === "positions" ? "0"
                        : ContentSavedTitle.length +
                        AddedBookmarkPosition.length -
                        RemovedBookmarkPosition.length}{" "}
                      {translateText("selected")}
                    </span>
                  )}
                  {SelectedDataName === "projects" && (
                    <span>
                      {HasRemoveAllSelectedJPABookmark.hasRemoved && HasRemoveAllSelectedJPABookmark.JPAType === "projects" ? "0"
                        : ContentSavedTitle.length +
                        AddedBookmarkProject.length -
                        RemovedBookmarkProject.length}{" "}
                      {translateText("selected")}
                    </span>
                  )}
                  {SelectedDataName === "activities" && (
                    <span>
                      {HasRemoveAllSelectedJPABookmark.hasRemoved && HasRemoveAllSelectedJPABookmark.JPAType === "activities" ? "0"
                        : ContentSavedTitle.length +
                        AddedBookmarkActivity.length -
                        RemovedBookmarkActivity.length}{" "}
                      {translateText("selected")}
                    </span>
                  )}
                  <span className="feather-chevron-down" />
                </div>
              )}
            </div>
            <div className="content-saved">
              <div className="content-saved-close">
                <i className="feather-x" onClick={handleFlippedCard}></i>
              </div>
              <div className="content-saved-btn" onClick={() => handleSave()}>
                {translateText("save")}
              </div>
            </div>
          </div>
        ) : (
          <div className="candidate-card-front">
            <div className="candidate-profile">
              {props.candidate.imageThumbnailUrl === null ? (
                <div
                  className="image-placeholder"
                  style={{
                    color: props.candidate.textColorCode,
                    backgroundColor: props.candidate.backgroundColorCode,
                  }}
                >
                  {props.candidate.firstName.slice(0, 1).toUpperCase() +
                    props.candidate.lastName.slice(0, 1).toUpperCase()}
                </div>
              ) : (
                <img
                  src={props.candidate.imageThumbnailUrl}
                  alt="profile-img"
                  width={32}
                  height={32}
                />
              )}
              <div>
                <p className="candidate-name">
                  {shortenText(
                    props.candidate.firstName + " " + props.candidate.lastName,
                    40
                  )}
                </p>
                <p className="candidate-job">
                  {shortenText(props.candidate.currentPositionTitle, 40)}
                </p>
              </div>
            </div>
            <div className="candidate-utils">
              <div className="candidate-save">
                {TotalContentSaved ? (
                  <IcSaved
                    className="candidate-save-btn"
                    onClick={handleFlippedCard}
                  />
                ) : (
                  <IcSave
                    className="candidate-save-btn"
                    onClick={handleFlippedCard}
                  />
                )}
                <PercentageIndicator
                  Percentage={parseInt(props.candidate.similarity * 100)}
                />
              </div>
              <div
                className="candidate-more-details"
                onClick={() => setModalIsOpen(true)}
              >
                {translateText("more_details")}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CandidateCard;
